import { useEffect, useState } from "react";
import AnimatedTextInput from "../../components/animatedTextInput";
import { Link, useHistory } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";
import { useTranslation } from "react-i18next";
import { parseNumberFromAnotherLocale } from "../../utils";

function UpdateMobile({ setNewTokenOTP, setToVerifyNumber }) {
  const [text, setText] = useState("");
  const [mobileText, setMobileText] = useState("");
  const history = useHistory();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => setText(e.target.value);
  const { t } = useTranslation();

  useEffect(() => {
    // Valid mobile values
    // 10 digits, can contain spaces
    // If the string is in hindi / marathi locale
    try {
      const stripSpaces = text.replace(/\s/g, "");
      if (stripSpaces !== "") {
        setMobileText(parseNumberFromAnotherLocale(stripSpaces));
      }
      const isValid = stripSpaces.length === 10 || text === "";
      if (!isValid) {
        setErrorMessage(t("onboard.MOBILE.error"));
      }
      setShowError(!isValid);
    } catch (e) {
      setErrorMessage("Unable to parse input");
      setShowError(true);
    }
  }, [text]);

  // update mobile number
  const changeMobile = async () => {
    const token = "Bearer " + localStorage.getItem("token");
    const POST_URL = `/api/v1/users/profile/mobile/otp/${mobileText}`;
    try {
      const response = await fetch(`${POST_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(),
        credentials: "include",
      });
      const res = await response.json();
      // console.log(res);
      setNewTokenOTP(res);
      if (res.status.code !== 200) {
        setShowError(true);
        setErrorMessage(res.status.message);
        setText("");
      } else {
        setShowError(false);
        setErrorMessage("");
        history.push("/update-mobile-verify");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onSendOTP = () => {
    changeMobile();
    setToVerifyNumber(text);
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/setting" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.MOBILE.detail")}</span>
          </Link>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body ">
          <h3 className="headtitle">{t("sidenav.MOBILE.question")}</h3>

          <div className="fill_form light_fill_form">
            <AnimatedTextInput
              label={t("sidenav.MOBILE.inputLbl")}
              value={text}
              onChange={handleChange}
              isFocused={true}
              type={"number"}
            />
            <div>
              {showError && (
                <p className="ml-3 txt_color_orange">{errorMessage}</p>
              )}
            </div>
            <div className="btn_block d-flex justify-content-center bottom_button">
              <button
                className="btn btn_primary nextstep_cta"
                disabled={!text}
                onClick={onSendOTP}
              >
                {t("sidenav.MOBILE.otp")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateMobile;
